import { useParams } from "react-router-dom";
import ProfileView from "../components/ProfileView";
export default function ViewUserProfile() {
  const { userId } = useParams();
  return <ProfileView uid={userId} />;
}
